export default __webpack_public_path__ + "locales/ar-SA/SocialAuthWelcomeDialog.json?hash=4c0436863ea395c851b077bbecd15b6d";